import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GoogleAnalyticsService } from 'src/app/analytics/google.analytics.service';
import { ConnectionService } from 'src/app/shared-services/connection.service';
import { environment } from 'src/environments/environment';
declare var $: any;

@Component({
    selector: 'app-finicity',
    templateUrl: './finicity.component.html',
    styleUrls: ['./finicity.component.css', '../application.component.css']
})
export class FinicityComponent implements OnInit {

    @Input() token: any;
    @Input() referralPage: any;
    @Input() primaryOwner: any;
    @Input() applicationId: number = 0;

    @Output() onFinicityCompleted = new EventEmitter<any>();
    @Output() onFinicityLinkSentError = new EventEmitter<any>();
    @Output() onFinicityErrorCompleted = new EventEmitter<any>();
    @Output() onFinicityLinkSentSuccess = new EventEmitter<any>();

    googleVariant: any;
    tryCount: number = 0;
    googleExperience: any;
    loading: boolean = false;

    private errorGettingOffers: boolean;
    private finicityCompletedError: boolean;

    constructor(
        private connectionService: ConnectionService,
        private router: Router,
        private googleAnalyticsService: GoogleAnalyticsService,
        private route: ActivatedRoute
    ) { }

    ngOnInit(): void {
        this.googleExperience = this.route.snapshot.queryParams.google_experience;
        this.googleVariant = this.route.snapshot.queryParams.google_variant;
        this.getFinicityURL(this.applicationId);
    }

    getFinicityURL(applicationId: number) {
        return new Promise((resolve, reject) => {
            const url = `${environment.gateway}${this.token ? 'applicationNl/' : 'application/'}${applicationId}/vod/information`;
            this.connectionService.getCustomRequest(url, 'application/json', undefined, this.token ? 'token' : null, this.token).subscribe(
                (data: any) => {
                    if (data.object) {
                        if (data.object.url) {
                            window['finicityConnect'].launch(data.object.url, {
                                selector: '#finicityIframe',
                                overlay: 'rgba(255,255,255, 0)',
                                success: (event: any) => {
                                    let customDimensions = {};
                                    customDimensions[environment.GA_DIMENSIONS.REFERRAL_PAGE] = this.referralPage;
                                    this.trackEvent('finicity-uploaded');
                                    if (event.reason == 'complete' && event.code == 200) {
                                        this.loading = true;
                                        this.tryCount = 0;
                                        this.validateTransaction(applicationId).then(
                                            (vData: any) => {
                                                this.onFinicityCompleted.emit(vData);
                                            },
                                            (vError: any) => {
                                                this.finicityCompletedError = true;
                                                this.onFinicityErrorCompleted.emit(vError);
                                            }
                                        );
                                    }
                                },
                                cancel: (event: any) => { void (0); },
                                error: (error: any) => { void (0); },
                                loaded: () => { $('div.finicityIframe')[0].appendChild($('#finicityConnectIframe')[0]); },
                                route: (event: any) => { void (0); },
                                user: (event: any) => { void (0); }
                            });
                        } else { this.router.navigateByUrl('/application/error', { state: { customerName: this.primaryOwner.getOwnerName(0) } }); }
                    }
                    resolve(data);
                },
                (error: any) => {
                    this.errorGettingOffers = true;
                    reject(error);
                }
            );
        });
    }

    validateTransaction(applicationId: number) {
        this.tryCount += 1;
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                this.connectionService.getRequestUnsecured(`${environment.gateway}application/transaction/validate/${applicationId}`, 'application/json').subscribe(
                    (data: any) => {
                        if (data.object) {
                            resolve(data);
                        } else if (this.tryCount < 3) {
                            this.validateTransaction(applicationId).then(
                                (vData: any) => resolve(vData),
                                (vError: any) => reject(vError)
                            );
                        } else {
                            reject(data);
                        }
                    }, (error: any) => {
                        reject(error);
                    }
                );
            }, 40000);
        });
    }

    trackEvent(event: string) {
        let customDimensions = {};
        customDimensions[environment.GA_DIMENSIONS.REFERRAL_PAGE] = this.referralPage;
        customDimensions[environment.GA_DIMENSIONS.GOOGLE_EXPERIENCE] = this.googleExperience ? this.googleExperience : undefined;
        customDimensions[environment.GA_DIMENSIONS.GOOGLE_VARIANT] = this.googleVariant ? this.googleVariant : undefined;
        this.googleAnalyticsService.trackEvent('application', event, this.token ? 'application-token' : 'application', 1, this.token ? customDimensions : null);
    }

    sendFinicityVerifyBankAccountEmail() {
        return new Promise((resolve, reject) => {
            this.connectionService.getCustomRequest(`${environment.gateway}application/finicity-link/${this.applicationId}`, 'application/json', `newEmail=${null}`, this.token ? 'token' : null, this.token).subscribe(
                (data: any) => {
                    this.onFinicityLinkSentSuccess.emit(data);
                    resolve(data);
                },
                (error: any) => {
                    this.onFinicityLinkSentError.emit(error.error.msg);
                    reject(error);
                }
            );
        });
    }
}
